<template>
    <div class="pro-report-container" :style="proReportContainerStyle">
        <CommErrorContainer
            v-if="hasError"
            :errorDescription="errorMessage.description"
            :errorTitle="errorMessage.title"
        >
            <template #error-image>
                <img class="error-image" src="../../public/assets/images/img_404_report.png" alt="빈 리포트 이미지" />
            </template>
        </CommErrorContainer>
        <!-- NOTE: 테스트 서버(알파/베타)만 적용 -->
        <!-- <div class="floating-test-date" v-if="isShowTestDate && !isProduction && !props.isAdmin">
            <div class="test-date-header">
                <span>테스트 날짜</span>
                <button class="close-btn" @click="closeTestDate">×</button>
            </div>
            <input type="date" v-model="testDate" />
            <button @click="handleTestDate">확인</button>
        </div> -->

        <!-- 테스트 날짜 버튼 -->
        <!-- <button v-if="!isProduction && !props.isAdmin" class="floating-test-date-btn" @click="openTestDate">
            <span>T</span>
        </button> -->

        <!-- 구독 정보 영역 -->
        <div class="monthly-pro-report-wrap" :style="{ ...reportContainerStyle }" v-if="!isLoading">
            <div v-if="props.isAdmin" class="admin-info-header">
                <div class="report-info-tooltip-wrap">
                    <button class="report-info-btn" @click.stop="toggleTooltip">
                        <span class="info-icon">ⓘ</span>
                        <span class="body-4">리포트 정보</span>
                    </button>

                    <Transition name="fade">
                        <div v-if="isShowTooltip" class="report-info-tooltip" ref="tooltipRef">
                            <div class="tooltip-section user-info">
                                <p class="tooltip-title h6">기본 정보</p>
                                <div class="info-row-wrap">
                                    <div class="info-row">
                                        <span class="label">UID</span>
                                        <span class="value">
                                            {{ props.selectedAdminData?.Uid }}
                                        </span>
                                    </div>
                                    <div class="info-row">
                                        <span class="label">나이/성별</span>
                                        <span class="value">
                                            {{ (computedStore.computedModuleData as any)?.UserBasicInfo?.Age }}세 /
                                            {{
                                                (computedStore.computedModuleData as any)?.UserBasicInfo?.Gender === 'M'
                                                    ? '남성'
                                                    : '여성'
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="tooltip-section cluster-info">
                                <div class="cluster-card-wrap">
                                    <!-- 시작 클러스터 -->
                                    <div class="cluster-card start">
                                        <p class="card-label">시작</p>
                                        <p class="cluster-name body-4--bold">
                                            {{
                                                (computedStore.computedModuleData as any)?.UserBasicInfo?.StartCluster
                                                    ?.ClusterName
                                            }}
                                        </p>
                                        <div class="index-row">
                                            <span>
                                                BMI
                                                {{
                                                    (computedStore.computedModuleData as any)?.UserBasicInfo
                                                        ?.StartCluster?.BMIIndex
                                                }}
                                            </span>
                                            <span class="divider">|</span>
                                            <span>
                                                PBF
                                                {{
                                                    (computedStore.computedModuleData as any)?.UserBasicInfo
                                                        ?.StartCluster?.PBFIndex
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="arrow-icon">→</div>
                                    <!-- 종료 클러스터 -->
                                    <div class="cluster-card end">
                                        <p class="card-label">종료</p>
                                        <p class="cluster-name body-4--bold">
                                            {{
                                                (computedStore.computedModuleData as any)?.UserBasicInfo?.EndCluster
                                                    ?.ClusterName
                                            }}
                                        </p>
                                        <div class="index-row">
                                            <span>
                                                BMI
                                                {{
                                                    (computedStore.computedModuleData as any)?.UserBasicInfo?.EndCluster
                                                        ?.BMIIndex
                                                }}
                                            </span>
                                            <span class="divider">|</span>
                                            <span>
                                                PBF
                                                {{
                                                    (computedStore.computedModuleData as any)?.UserBasicInfo?.EndCluster
                                                        ?.PBFIndex
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
            <div class="fit-pro-information-area-wrap" v-show="!isSubscribed && !props.isAdmin">
                <div class="fit-pro-information-area">
                    <p class="content-1 body-3">
                        {{ SUBSCRIPTION_INFORMATION_TEXT.content?.[0] }}
                    </p>
                    <p class="content-2 body-3--regular">
                        {{ SUBSCRIPTION_INFORMATION_TEXT.content?.[1] }}
                    </p>
                    <button class="go-fitplus-pro-page-btn body-3" @click="handleGoFitplusProPage">
                        {{ SUBSCRIPTION_INFORMATION_TEXT.buttonText }}
                    </button>
                </div>
            </div>

            <div class="pro-report-wrap" v-show="!isLoading && computedStore.computedTimeseriesData">
                <TrendReportDateInfo
                    v-show="computedStore.computedTimeseriesData"
                    :moduleData="computedStore.computedModuleData"
                    :reportExistingEndDates="computedStore.reportExistingEndDates"
                    :currentSelectedEndDate="computedStore.currentSelectedEndDate ?? ''"
                    :timeseriesData="computedStore.computedTimeseriesData"
                    :isAdmin="props.isAdmin"
                    :reportType="props.selectedAdminData?.ReportType ?? ''"
                    :userUid="props.selectedAdminData?.Uid ? String(props.selectedAdminData.Uid) : undefined"
                    @change:month="handleChangeMonth"
                    @click:status="handleClickStatus"
                />
                <!-- 빈 화면 -->
                <!-- 타임시리즈가 null && 모듈데이터 ModuleBodyResDtoList.lenght < 1 -->
                <div
                    class="empty-wrap"
                    v-if="
                        !isLoading &&
                        isReadyForReportContent &&
                        (!computedStore.computedModuleData?.ModuleBodyResDtoList ||
                            computedStore.computedModuleData.ModuleBodyResDtoList.length < 1)
                    "
                >
                    <img
                        src="../../public/assets/images/img_empty_report.png"
                        alt="빈 리포트 이미지"
                        class="empty-image"
                        loading="eager"
                        fetchpriority="high"
                    />
                    <div class="empty-text-wrap">
                        <p class="empty-big-text h2">리포트가 없습니다.</p>
                        <p class="empty-text body-3--regular">이 기간의 변화리포트가 발행되지 않았습니다.</p>
                    </div>
                </div>
                <!-- 변화 그래프 -->
                <div
                    class="change-line-total-graph-container"
                    :class="{ floating: isHiddenFloatingBtn }"
                    ref="graphContainerRef"
                    v-if="
                        computedStore.computedModuleData?.ModuleBodyResDtoList &&
                        computedStore.computedModuleData.ModuleBodyResDtoList.length > 0
                    "
                >
                    <MonthlyChangeLineTotalGraph
                        v-if="readyForGraph"
                        :isAdmin="props.isAdmin"
                        :uid="props.isAdmin ? String(props.selectedAdminData?.Uid) : null"
                        :isFloatingMode="isHiddenFloatingBtn"
                        :timeseriesOriginData="computedStore.computedTimeseriesData"
                        :screenWidth="screenWidth"
                        :key="computedStore.currentSelectedEndDate || 'default'"
                    />
                    <ReportCautionText
                        v-if="!isFirstModuleSummaryModule"
                        :text="computedStore.computedModuleData?.CautionText"
                        margin="1rem 1.5rem 1.6rem 1.5rem"
                    />
                </div>

                <!-- placeholder 영역 -->
                <!-- <div
                    class="graph-placeholder"
                    :style="{
                        height: graphHeight + 'px',
                        opacity: isHiddenFloatingBtn ? 1 : 0,
                        visibility: isHiddenFloatingBtn ? 'visible' : 'hidden',
                        transition: 'opacity 0.3s ease',
                    }"
                /> -->

                <!-- 모듈 데이터 표시 -->
                <div v-if="computedStore.computedModuleData?.ModuleBodyResDtoList">
                    <TrendReportModuleSections
                        :key="computedStore.currentSelectedEndDate || 'default'"
                        :computedStore="computedStore"
                        :screenWidth="screenWidth"
                        :isAdmin="props.isAdmin"
                        :showAllImmediately="props.isAdmin || (computedStore.computedModuleData?.ReadCount ?? 1) > 0"
                        :handleFloatingBtnClick="handleFloatingBtnClick"
                        :isFloatingFixed="isFloatingFixed"
                        :isHiddenFloatingBtn="isHiddenFloatingBtn"
                        :handleReferenceItemClick="handleReferenceItemClick"
                        :makeVelocityGraphKey="makeVelocityGraphKey"
                        :makeClusterGraphKey="makeClusterGraphKey"
                        :month="computedStore.currentSelectedEndDate ?? null"
                        :endDate="computedStore.currentSelectedEndDate ?? null"
                        :cautionText="computedStore.computedModuleData?.CautionText ?? null"
                        @all-done="handleAllDone"
                    />

                    <!-- 리포트 평가 -->
                    <TrendReportFeedbackCheck
                        :userFeedback="computedStore.computedModuleData?.UserFeedback!"
                        v-if="computedShowFeedbackCheck"
                        @updateUserFeedbackData="handleUpdateUserFeedbackData"
                    />

                    <CommBRButton
                        v-if="computedShowShareButton"
                        class="share-button"
                        text="리포트 공유하기"
                        :bgColor="'linear-gradient(128.44deg, #00B3FF 3.83%, #1377C4 139.28%)'"
                        textColor="#fff"
                        fontSize="1.6rem"
                        padding="1.5rem"
                        borderRadius="1.5rem"
                        shadow="0px 10px 10px 0px #1377C433"
                        @clickButton="handleClickShareReport"
                    />
                </div>
            </div>
        </div>

        <TrendReportBeforeFirstReport
            v-if="
                !props.isAdmin &&
                computedStore.reportExistingEndDates?.length === 0 &&
                proReportStore.eligibilityTrackingCardData
            "
            :headerHeight="HEADER_HEIGHT"
            :reportContainerBottomPadding="reportContainerBottomPadding"
            :isSubscribed="isSubscribed"
            :data="proReportStore.eligibilityTrackingCardData"
            :reportExistingEndDates="computedStore.reportExistingEndDates"
            :cardHeight="cardHeight"
        />
        <!-- 발급 조건 트래킹 카드 -->
        <div class="tracking-card-slot">
            <Transition name="slide-card">
                <TrendReportEligibiliyTrackingCard
                    :cardData="proReportStore.eligibilityTrackingCardData?.ReportConditionTrackingModuleSchema"
                    :forceCollapsed="shouldForceCollapse"
                    v-show="
                        !props.isAdmin &&
                        !isReportPublished &&
                        !isHideCards &&
                        !proReportStore.eligibilityTrackingCardData?.IsWaitingPublish &&
                        proReportStore.eligibilityTrackingCardData?.ReportConditionTrackingModuleSchema
                    "
                />
            </Transition>
        </div>
        <!-- 발급 전 진행상황 카드 -->
        <Transition name="slide-card">
            <TrendReportEligibilityPrepareCard
                @clickPublish="handleClickPublish"
                :cardData="proReportStore.eligibilityTrackingCardData?.WaitingPublishModuleSchema"
                v-if="
                    !props.isAdmin &&
                    !isReportPublished &&
                    !isHideCards &&
                    proReportStore.eligibilityTrackingCardData?.IsWaitingPublish &&
                    proReportStore.eligibilityTrackingCardData?.WaitingPublishModuleSchema
                "
            />
        </Transition>

        <Transition name="slide-modal">
            <ReferenceBottomSheet
                :referenceInfo="referenceInfo"
                :positionStyle="props.isAdmin ? 'position: sticky' : 'position: fixed'"
                v-if="isShowReferenceBottomSheet"
                @close="handleCloseReferenceBottomSheet"
            />
        </Transition>
        <Transition name="slide-modal">
            <EvaluationDescBottomSheet
                :evaluationDescInfo="evaluationDescInfo"
                :positionStyle="props.isAdmin ? 'position: sticky' : 'position: fixed'"
                v-if="isShowEvaluationDescBottomSheet"
                @close="handleCloseEvaluationDescBottomSheet"
            />
        </Transition>
        <Transition name="slide-modal">
            <ChangeStatusDescBottomSheet
                :positionStyle="props.isAdmin ? 'position: sticky' : 'position: fixed'"
                v-if="isShowChangeStatusBottomSheet"
                @close="handleCloseChangeStatusBottomSheet"
            />
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch, computed, watchEffect, nextTick, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';
import CommErrorContainer from '@common/common/components/CommErrorContainer.vue';
import TrendReportDateInfo from '../components/trendReport/TrendReportDateInfo.vue';
import MonthlyChangeLineTotalGraph from '../components/graph/MonthlyChangeLineTotalGraph.vue';
import TrendReportFeedbackCheck from '../components/trendReport/TrendReportFeedbackCheck.vue';
import TrendReportModuleSections from '../components/trendReport/TrendReportModuleSections.vue';
import { lazyCommReferenceBottomSheet, lazyCommEvaluationDescBottomSheet } from '../lazy';
import TrendReportEligibiliyTrackingCard from '../components/trendReport/TrendReportEligibiliyTrackingCard.vue';
import TrendReportEligibilityPrepareCard from '../components/trendReport/TrendReportEligibilityPrepareCard.vue';
import CommBRButton from '@common/common/components/CommBRButton.vue';
import ChangeStatusDescBottomSheet from '../components/common/CommChangeStatusDescBottomSheet.vue';
import ReportCautionText from '../components/common/ReportCautionText.vue';
import { useUserInteractionLog } from '../composables/useUserInteractionLog';
import TrendReportBeforeFirstReport from '../components/trendReport/TrendReportBeforeFirstReport.vue';
const ReferenceBottomSheet = defineAsyncComponent(lazyCommReferenceBottomSheet);
const EvaluationDescBottomSheet = defineAsyncComponent(lazyCommEvaluationDescBottomSheet);

import useProReportStore from '../stores/proReport';
import useProReportAdminStore from '../stores/proReportAdmin';
import { SUBSCRIPTION_INFORMATION_TEXT } from '../const/pageText';
import {
    appShareLink,
    callNavigateToProSubscribe,
    callNavigateToProSubscribeV2,
    sendHeaderHiddenStatusToNative,
} from '@common/common/utils/utils';
import type {
    Evaluation,
    ManagingPageContentsInfo,
    ReferenceSchema,
    UserFeedback,
} from '@common/openapi-client/openapi';
import type { ReferenceInfo } from '../types/proReport';
import useErrorStore from '../stores/error';
import { useI18n } from 'vue-i18n';
import Cookies from 'js-cookie';

const { t } = useI18n();

const proReportStore = useProReportStore();
const proReportAdminStore = useProReportAdminStore();
const errorStore = useErrorStore();
const route = useRoute();

const screenWidth = ref(0);
const graphContainerRef = ref<HTMLElement | null>(null);
const readyForGraph = ref(false);
const graphHeight = ref(0);

const isFloatingFixed = ref(false);
const isHiddenFloatingBtn = ref(false);
const isShowReferenceBottomSheet = ref(false);
const isShowEvaluationDescBottomSheet = ref(false);
const isShowChangeStatusBottomSheet = ref(false);
const isSubscribed = ref(false);
const isShowFeedbackCheckComp = ref(false);
const isShowShareButton = ref(false);
const isShowTooltip = ref(false);
const tooltipRef = ref<HTMLElement | null>(null);

const toggleTooltip = () => {
    isShowTooltip.value = !isShowTooltip.value;
};

const closeTooltip = (event: MouseEvent) => {
    if (tooltipRef.value && !tooltipRef.value.contains(event.target as Node)) {
        isShowTooltip.value = false;
    }
};

// const isShowTestDate = ref(false);
const isScrollingDown = ref(false);
const isCardAvailableForCurrentDate = ref(false);
const isReportPublished = ref(false);

// 테스트용 날짜 관련 - 스토어에서 관리
const nowParam = route.query.now as string;
proReportStore.initTestDate(nowParam);
const testDate = ref(proReportStore.testDate);

// testDate 변경 시 스토어도 업데이트
watch(testDate, newValue => {
    proReportStore.testDate = newValue;
});

const evaluationDescInfo = ref<Evaluation | null>(null);
const isLoading = ref(true);
const isHideCards = ref(false);
const hasError = ref(false);
const errorMessage = {
    title: '리포트를 불러올 수 없습니다.',
    description: '리포트를 불러오는 중 오류가 발생했습니다.\n 앱을 다시 실행해주세요.',
};
const cardHeight = ref(0);

// 관리자 데이터 전달
const props = defineProps<{
    isAdmin?: boolean;
    width?: string;
    selectedAdminData?: ManagingPageContentsInfo;
}>();

const { saveLog } = useUserInteractionLog(props.isAdmin);

watch(isHiddenFloatingBtn, newVal => {
    if (newVal && graphContainerRef.value) {
        graphHeight.value = graphContainerRef.value.offsetHeight;
    } else {
        graphHeight.value = 0;
    }
});

// AIDEV-NOTE: 관리자 전용 경로 (selectedAdminData 는 관리자 페이지에서만 내려온다).
watchEffect(() => {
    const data = props.selectedAdminData;
    if (data) {
        // 월 캐시 초기화 + 새 요청 세대 발급.
        // 세대를 올려야 진행 중이던 이전 행의 체인이 늦게 도착해도 캐시를 오염시키지 못한다.
        const seq = proReportAdminStore.beginReportSession(data.EndDate ?? null);

        if (!data.TimeSeriesData) {
            alert('TimeseriesData가 없습니다.');
            isLoading.value = false;
            return;
        }

        isLoading.value = true;

        proReportAdminStore
            .getReportExistingEndDates(String(data.Uid), seq)
            .then(() =>
                // AIDEV-NOTE: return 해야 .finally 가 모듈 데이터 로딩까지 기다린다.
                // 예전엔 return 이 없어 스피너가 먼저 꺼지고 빈/이전 화면이 노출됐다.
                proReportAdminStore.updateMonthlySurroundingData(
                    String(data.Uid),
                    data.EndDate ?? '',
                    Number(data.Version),
                    data.ReportType ?? '',
                    seq,
                ),
            )
            .finally(() => {
                // 다른 행이 선택돼 폐기된 체인이면, 진행 중인 새 체인의 스피너를 끄지 않는다.
                // (월 이동에 밀린 경우는 스피너를 꺼야 하므로 isStale 이 아닌 isStaleSession 을 쓴다)
                if (proReportAdminStore.isStaleSession(seq)) return;

                isLoading.value = false;

                // 다른 리포트 조회 시 scrollTop 초기화
                if (props.isAdmin) {
                    const mobileScreenEl = document.querySelector('.mobile-screen');

                    if (mobileScreenEl) {
                        mobileScreenEl.scrollTo({
                            top: 0,
                            behavior: 'auto',
                        });
                    }
                }
            });
    }
});

const computedStore = computed(() => {
    if (props.isAdmin) {
        return proReportAdminStore;
    } else {
        return proReportStore;
    }
});

// 프로덕션 환경 체크
// const isProduction = ref(import.meta.env.MODE === 'production');

// 카드 높이 측정 및 초기 애니메이션 실행
watchEffect(() => {
    // reportExistingEndDates가 있고, 현재 보고 있는 날짜가 마지막 날짜보다 이전인지 확인
    if (proReportStore.reportExistingEndDates.length > 0) {
        const lastDate = proReportStore.reportExistingEndDates[proReportStore.reportExistingEndDates.length - 1];
        const currentDate = computedStore.value.currentSelectedEndDate;

        if (currentDate && lastDate) {
            // 날짜 문자열을 Date 객체로 변환하여 비교
            const lastDateObj = new Date(lastDate);
            const currentDateObj = new Date(currentDate);

            // 현재 보고 있는 날짜가 마지막 날짜보다 이전이면 카드 사용 불가
            if (currentDateObj < lastDateObj) {
                isCardAvailableForCurrentDate.value = false;
                isHideCards.value = true;
            } else {
                // 이번달 포함 이후의 미래 날짜에서는 카드 사용 가능
                isCardAvailableForCurrentDate.value = true;
                // 스크롤 상태에 따라 카드 표시/숨김 결정
                if (isScrollingDown.value) {
                    isHideCards.value = true;
                } else {
                    isHideCards.value = false;
                }
            }
        }
    }

    if (isHideCards.value) {
        cardHeight.value = 0;
        return;
    }

    const hasTrackingCard =
        proReportStore.eligibilityTrackingCardData && !proReportStore.eligibilityTrackingCardData.IsWaitingPublish;

    const hasPrepareCard =
        proReportStore.eligibilityTrackingCardData && proReportStore.eligibilityTrackingCardData.IsWaitingPublish;

    if (hasTrackingCard || hasPrepareCard) {
        nextTick(() => {
            const cardElement = document.querySelector('.eligibility-tracking-card') as HTMLElement;
            if (cardElement) {
                cardHeight.value = cardElement.offsetHeight;
            }
        });
    } else {
        cardHeight.value = 0;
    }
});

const makeVelocityGraphKey = (graphData: any): string => {
    const type = graphData?.GraphType ?? 'unknown';
    const dto = type === 'Histogram' ? graphData.VarianceHistogramResDto : graphData.VarianceVarianceResDto;

    const bodyComp = dto?.BodyComp ?? 'none';
    const gender = dto?.FilterInfo?.['Gender'] ?? 'none';
    const age = dto?.FilterInfo?.['AGE'] ?? 'none';
    const bodyType = dto?.FilterInfo?.['BodyType'] ?? 'none';

    return `${type}-${bodyComp}-${gender}-${age}-${bodyType}`;
};

const makeClusterGraphKey = (graphData: any): string => {
    const type = graphData?.GraphType ?? 'unknown';

    return `${type}-${props.selectedAdminData?.Uid}-${props.selectedAdminData?.EndDate}-${props.selectedAdminData?.Version}`;
};

const HEADER_HEIGHT = 110;

const reportContainerStyle = computed(() => {
    // 네이티브 상단 메뉴바 높이 맞추기 위해 사용
    if (props.isAdmin) {
        return {};
    }

    // 리포트 발급이 안됐을 경우
    if (computedStore.value.reportExistingEndDates.length === 0) {
        if (!isSubscribed.value) {
            return {
                marginTop: `${HEADER_HEIGHT}px`,
            };
        } else {
            return {};
        }
    } else {
        return {
            marginTop: `${HEADER_HEIGHT}px`,
            ...reportContainerBottomPadding.value,
        };
    }
});

const proReportContainerStyle = computed(() => {
    // reportExistingEndDates가 비어있고 구독하지 않은 경우 reportContainerBottomPadding 적용
    if (computedStore.value.reportExistingEndDates.length === 0 && !isSubscribed.value) {
        return {
            ...reportContainerBottomPadding.value,
        };
    }
    return {};
});

const reportContainerBottomPadding = computed(() => {
    if (isHideCards.value) return {};

    // 카드가 표시되는 경우 카드 높이만큼 패딩 추가
    const isTrackingCardVisible =
        proReportStore.eligibilityTrackingCardData && !proReportStore.eligibilityTrackingCardData.IsWaitingPublish;

    const isPrepareCardVisible =
        proReportStore.eligibilityTrackingCardData && proReportStore.eligibilityTrackingCardData.IsWaitingPublish;

    if (isTrackingCardVisible || isPrepareCardVisible) {
        // 동적으로 측정된 카드 높이 사용
        return cardHeight.value > 0
            ? {
                  paddingBottom: `${cardHeight.value}px`,
              }
            : {};
    }

    return {};
});

// 데이터 로딩 처리를 위한 값
const isReadyForReportContent = computed(() => {
    if (!props.isAdmin) return true; // 일반 사용자는 항상 true

    const selectedKey = proReportAdminStore.currentSelectedEndDate;

    if (!selectedKey) return false;

    return computedStore.value.computedTimeseriesData !== null || computedStore.value.computedModuleData !== null;
});

const setInitData = async () => {
    isLoading.value = true;
    hasError.value = false;

    screenWidth.value = props.width ? Number(props.width) - 30 : window.screen.width ? window.screen.width - 30 : 400;

    // 웹뷰 데이터 호출
    if (!props.isAdmin) {
        try {
            const [isSubscribedResult, eligibilityTrackingCardData, reportExistingEndDates] = await Promise.all([
                proReportStore.getSubscriptionStatus(),
                proReportStore.getEligibilityTrackingCardData(testDate.value),
                proReportStore.getReportExistingEndDates(testDate.value),
            ]).catch(error => {
                errorStore.setError({
                    errorType: 'GLOBAL_ERROR',
                    errorAction: 'CLOSE_MODAL',
                    errorMessage: t('error_message_global_error'),
                });
                console.error('초기 데이터 호출 에러', error);
                throw error;
            });
            // 구독 여부
            isSubscribed.value = isSubscribedResult;
            // 발행된 리포트 리스트
            const hasTrendReportHistory = (reportExistingEndDates?.length ?? 0) > 0;
            // 신규발급 여부
            const firstReport = !hasTrendReportHistory;

            const { IsWaitingPublish, WaitingPublishModuleSchema, UserName } = eligibilityTrackingCardData;

            /** 
                IsWaitingPublish - true 리포트 발급 가능하여 승인 대기중 or 발급받기 대기 
                IsWaitingPublish - false 리포트 발급 가능한지 트래킹중
                
                1. IsWaitingPublish - true + Data.WaitingPublishModuleSchema.ReportPublishButton - true면 <신규화면 || 이전달 호출>,
                2. IsWaitingPublish- true + Data.WaitingPublishModuleSchema.ReportPublishButton - false면 <신규화면 || 이전달 호출>
                
                3. IsWaitingPublish - false면 무조건 <신규화면 || trend-report/report-existing-end-dates 마지막 호출>

                * 리포트 발급 후 화면 분기
                - readCount > 0 -> 리포트 화면 / 발급조건 트래킹 카드
                - readCount = 0 -> 이번달 리포트 애니메이션 / 발급조건 트래킹 카드 숨김
            */

            function setPrepareReportData(dateCode: 'THIS_MONTH' | 'LAST_MONTH' | 'EXISTING_DATES_LAST_ITEM') {
                // 'EXISTING_DATES_LAST_ITEM' 경우 trend-report/report-existing-end-dates 리스트의 마지막 날짜
                if (firstReport) {
                    proReportStore.prepareReportData = {
                        userName: UserName ?? '',
                    };
                } else {
                    getForNativeReportData(dateCode);
                }
            }

            if (IsWaitingPublish) {
                // 리포트 발급 가능하여 승인 대기중 or 발급받기 대기
                if (WaitingPublishModuleSchema?.ReportPublishButton) {
                    // 이번달 리포트 발급 가능 상태. 이전달 호출 (날짜 스트링으로 호출)
                    setPrepareReportData('LAST_MONTH');
                } else {
                    // 이번달 리포트 발급 불가 상태. 이전달 호출 (trend-report/report-existing-end-dates 마지막 호출)
                    setPrepareReportData('EXISTING_DATES_LAST_ITEM');
                }
            } else {
                // 리포트 발급 트래킹
                setPrepareReportData('EXISTING_DATES_LAST_ITEM');
            }
        } catch (error) {
            console.error('초기 데이터 호출 에러', error);
            hasError.value = true;
        } finally {
            isLoading.value = false;
        }
    }
};

const computedShowFeedbackCheck = computed(() => {
    if (props.isAdmin || !computedStore.value.computedModuleData) return false;

    const userFeedback = computedStore.value.computedModuleData?.UserFeedback;
    if (!userFeedback) return false;

    const readCountNum = computedStore.value.computedModuleData?.ReadCount ?? 0;

    return readCountNum >= 1 || (readCountNum === 0 && isShowFeedbackCheckComp.value);
});

const computedShowShareButton = computed(() => {
    if (props.isAdmin || !computedStore.value.computedModuleData) return false;

    const readCountNum = computedStore.value.computedModuleData?.ReadCount ?? 0;
    const shouldShowFeedback = readCountNum >= 1 || (readCountNum === 0 && isShowFeedbackCheckComp.value);

    // 피드백 컴포넌트가 표시되어야 하고, 공유 버튼 플래그가 true일 때만 표시
    return shouldShowFeedback || isShowShareButton.value;
});

const isFirstModuleSummaryModule = computed(() => {
    const firstModule = computedStore.value.computedModuleData?.ModuleBodyResDtoList?.[0];
    return firstModule?.ModuleName === 'SummaryModule';
});

let lastScrollTop = ref(0);
let isHideHeader = ref(true); // 현재 상태 기억
let hasScrolledOnce = ref(false); // 첫 번째 스크롤 여부
let shouldForceCollapse = ref(false); // 카드 강제 접힘 여부

const handleScroll = () => {
    const containerEl = document.querySelector('.wrapper');
    const sectionEl = graphContainerRef.value;

    if (!sectionEl || !containerEl) return;

    const sectionRect = sectionEl.getBoundingClientRect();
    const currentScrollTop = containerEl.scrollTop;

    // 1. 맨 위에 닿았을 때
    if (currentScrollTop <= 0) {
        if (!isHideHeader.value) {
            sendHeaderHiddenStatusToNative(false);
            isHideHeader.value = true;
        }
        // 스크롤이 상단에 도달했을 때 카드 표시 (카드 사용 가능한 날짜에서만)
        if (isCardAvailableForCurrentDate.value) {
            isScrollingDown.value = false;
            isHideCards.value = false;

            // 첫 번째 스크롤 후 최상단으로 올라왔을 때 카드 접힘
            if (hasScrolledOnce.value && !shouldForceCollapse.value) {
                shouldForceCollapse.value = true;
            }
        }
    }
    // 2. 스크롤을 아래로 내릴 때 (그리고 기존 상태가 true였을 때만)
    else if (currentScrollTop > lastScrollTop.value) {
        if (isHideHeader.value) {
            sendHeaderHiddenStatusToNative(true);
            isHideHeader.value = false;
        }
        // 스크롤을 아래로 내릴 때 카드 숨김 (카드 사용 가능한 날짜에서만)
        if (isCardAvailableForCurrentDate.value) {
            isScrollingDown.value = true;
            isHideCards.value = true;
            // 첫 번째 스크롤 표시
            hasScrolledOnce.value = true;
        }
    }
    // 3. 현재 ScrollTop 위치가 .wrapper 클래스의 최상단 - 10 이하일 때 카드 표시
    else if (currentScrollTop <= 10) {
        if (isCardAvailableForCurrentDate.value) {
            isScrollingDown.value = false;
            isHideCards.value = false;
        }
    }

    lastScrollTop.value = currentScrollTop <= 0 ? 0 : currentScrollTop;

    // 기존 버튼 고정 처리 로직
    if (sectionRect.bottom <= 0) {
        isFloatingFixed.value = true;
    }
    if (containerEl.scrollTop <= 0) {
        isHiddenFloatingBtn.value = false;
        isFloatingFixed.value = false;
    }
};

const getTargetEndDate = (dateCode: 'THIS_MONTH' | 'LAST_MONTH' | 'EXISTING_DATES_LAST_ITEM'): string => {
    if (dateCode === 'THIS_MONTH') {
        // 이번달 (다음달의 첫 날)
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth();
        const nextMonth = new Date(year, month + 1, 1, 0, 0, 0);

        const yyyy = nextMonth.getFullYear();
        const mm = String(nextMonth.getMonth() + 1).padStart(2, '0');
        const dd = String(nextMonth.getDate()).padStart(2, '0');
        const hh = String(nextMonth.getHours()).padStart(2, '0');
        const min = String(nextMonth.getMinutes()).padStart(2, '0');
        const ss = String(nextMonth.getSeconds()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
    } else if (dateCode === 'LAST_MONTH') {
        // 저번달 데이터를 위해 현재 달의 첫 날 사용
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth();
        const currentMonthStart = new Date(year, month, 1, 0, 0, 0);

        const yyyy = currentMonthStart.getFullYear();
        const mm = String(currentMonthStart.getMonth() + 1).padStart(2, '0');
        const dd = String(currentMonthStart.getDate()).padStart(2, '0');
        const hh = String(currentMonthStart.getHours()).padStart(2, '0');
        const min = String(currentMonthStart.getMinutes()).padStart(2, '0');
        const ss = String(currentMonthStart.getSeconds()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
    } else if (dateCode === 'EXISTING_DATES_LAST_ITEM') {
        // reportExistingEndDates 배열의 마지막 요소 사용
        const existingDates = proReportStore.reportExistingEndDates;
        if (existingDates && existingDates.length > 0) {
            return existingDates[existingDates.length - 1];
        } else {
            // fallback으로 THIS_MONTH 사용
            return getTargetEndDate('THIS_MONTH');
        }
    }

    // fallback
    return getTargetEndDate('THIS_MONTH');
};

const getForNativeReportData = (dateCode: 'THIS_MONTH' | 'LAST_MONTH' | 'EXISTING_DATES_LAST_ITEM') => {
    if (!props.isAdmin) {
        // date 목록 호출
        const targetEndDate = getTargetEndDate(dateCode);

        proReportStore.updateMonthlySurroundingData(targetEndDate).then(() => {
            /** 
                * 리포트 발급 후 화면 분기
                - readCount > 0 -> 리포트 화면 / 발급조건 트래킹 카드
                - readCount = 0 -> 이번달 리포트 애니메이션 / 발급조건 트래킹 카드 숨김
            */
            saveLog(161, 'VIEW_REPORT', createReportLogValue());

            const readCount = proReportStore.computedModuleData?.ReadCount ?? 1;
            if (readCount === 0) {
                isHideCards.value = true;
            }
        });
    }
};

const getForNativeReportTargetData = (generationDateTime: string, reportType: string) => {
    if (!props.isAdmin) {
        const targetEndDate = generationDateTime;

        proReportStore.updateMonthlySurroundingData(targetEndDate, reportType).then(() => {
            // reportExistingEndDates.length가 0이 아니어야하기 때문에 수정
            computedStore.value.reportExistingEndDates.push(targetEndDate);
            const readCount = proReportStore.computedModuleData?.ReadCount ?? 1;
            if (readCount === 0) {
                isHideCards.value = true;
            }

            // 페이지 맨 밑으로 스크롤
            setTimeout(() => {
                const wrapper = document.querySelector('.wrapper');
                if (wrapper) {
                    wrapper.scrollTo({
                        top: wrapper.scrollHeight,
                        behavior: 'smooth',
                    });
                }
            }, 100);
        });
    }
};

const handleFloatingBtnClick = () => {
    if (!isFloatingFixed.value) {
        return;
    }
    isShowReferenceBottomSheet.value = false;
    isHiddenFloatingBtn.value = !isHiddenFloatingBtn.value;
};

const handleOpenEvaluationDescBottomSheet = (data: Evaluation) => {
    evaluationDescInfo.value = data;
    isShowEvaluationDescBottomSheet.value = true;
};

const handleOpenChangeEvaluationBottomSheet = () => {
    isShowChangeStatusBottomSheet.value = true;
};

const referenceInfo = ref<ReferenceInfo>({
    title: '',
    content: '',
});

const handleReferenceItemClick = (item: ReferenceSchema) => {
    isHiddenFloatingBtn.value = false;
    isShowReferenceBottomSheet.value = true;
    referenceInfo.value.title = item.ReferenceTitle ?? '';
    referenceInfo.value.content = item.ReferenceDescription ?? '';
};

const handleCloseReferenceBottomSheet = () => {
    isShowReferenceBottomSheet.value = false;
};

const handleCloseEvaluationDescBottomSheet = () => {
    isShowEvaluationDescBottomSheet.value = false;
};

const handleCloseChangeStatusBottomSheet = () => {
    isShowChangeStatusBottomSheet.value = false;
};

const handleGoFitplusProPage = () => {
    // iOS 에서는 특정 버전 이전, 이후 버전 코드가 다르므로 두 브릿지 키를 모두 호출해야함
    callNavigateToProSubscribe();
    callNavigateToProSubscribeV2();
};

const handleUpdateUserFeedbackData = (data: UserFeedback) => {
    proReportStore.updateUserFeedbackData(data);
};

// 월 변경 시 모듈 데이터 업데이트
const handleChangeMonth = async (offset: number) => {
    const baseEndDate = computedStore.value.currentSelectedEndDate;
    if (!baseEndDate) return;

    const baseDate = parseYMDToDate(baseEndDate);
    const target = new Date(baseDate);
    target.setMonth(baseDate.getMonth() + offset);

    const yyyy = target.getFullYear();
    const mm = String(target.getMonth() + 1).padStart(2, '0');
    const dd = '01';
    const endDate = `${yyyy}-${mm}-${dd}T00:00:00`;

    if (props.isAdmin) {
        await proReportAdminStore.updateMonthlySurroundingData(
            String(props.selectedAdminData?.Uid ?? ''),
            endDate,
            Number(props.selectedAdminData?.Version),
            props.selectedAdminData?.ReportType ?? '',
        );
    } else {
        isShowFeedbackCheckComp.value = false;
        isShowShareButton.value = false;
        // 월 변경 시 스크롤 상태 초기화 (단, hasScrolledOnce와 shouldForceCollapse는 유지)
        isScrollingDown.value = false;
        lastScrollTop.value = 0;
        proReportStore.updateMonthlySurroundingData(endDate).then(() => {
            saveLog(161, 'VIEW_REPORT', createReportLogValue());
        });
    }
};

const parseYMDToDate = (dateStr: string): Date => {
    const [year, month, day] = dateStr.split('T')[0].split('-').map(Number);
    return new Date(year, month - 1, day);
};

const handleClickStatus = (buttonType: string) => {
    if (buttonType === 'MEASURE_COUNT') {
        handleOpenChangeEvaluationBottomSheet();
        saveLog(161, 'CHECK_MEASURE_COUNT_CLICK');
    } else if (buttonType === 'CHANGE_EVALUATION') {
        handleOpenEvaluationDescBottomSheet(computedStore.value.computedTimeseriesData?.Evaluation ?? {});
        saveLog(161, 'CHANGE_EVALUATION_CLICK');
    }
};

const handleAllDone = async (userScrolled: boolean) => {
    isHideCards.value = false;
    isShowFeedbackCheckComp.value = true;

    // 피드백 컴포넌트가 표시된 후 약간의 지연을 두고 공유 버튼 표시
    setTimeout(async () => {
        isShowShareButton.value = true;

        // userScrolled가 true가 아닐 때만 스크롤 실행
        if (!userScrolled) {
            // DOM 업데이트를 기다린 후 스크롤
            await nextTick();

            // 추가 지연을 두어 공유 버튼이 완전히 렌더링된 후 스크롤
            setTimeout(() => {
                const appEl = document.querySelector('.wrapper') as HTMLElement | null;
                (appEl ?? document.scrollingElement ?? document.documentElement)?.scrollTo({
                    top: appEl?.scrollHeight ?? document.documentElement.scrollHeight,
                    behavior: 'smooth',
                });
            }, 100);
        }
    }, 500);

    if (userScrolled) {
        // 유저가 스크롤 동작을 실행했다면 스크롤 동작 중단
        return;
    }

    await nextTick(); // DOM 업데이트 후 높이 확정

    const appEl = document.querySelector('.wrapper') as HTMLElement | null;
    (appEl ?? document.scrollingElement ?? document.documentElement)?.scrollTo({
        top: appEl?.scrollHeight ?? document.documentElement.scrollHeight,
        behavior: 'smooth',
    });
};

const handleClickPublish = (generationDateTime: string, reportType: string) => {
    // 이번달 페이지로 이동
    // 애니메이션 실행을 위해 피드백 체크 컴포넌트 초기화
    isShowFeedbackCheckComp.value = false;
    isShowShareButton.value = false;

    // 카드 숨기기 및 리포트 발급 완료 플래그 설정
    isHideCards.value = true;
    isReportPublished.value = true;

    getForNativeReportTargetData(generationDateTime, reportType);
    saveLog(162, 'PUBLISH_REPORT_CLICK', '');
};

// const openTestDate = () => {
//     isShowTestDate.value = true;
// };

// const closeTestDate = () => {
//     isShowTestDate.value = false;
// };

// const handleTestDate = () => {
//     // 현재 쿼리 파라미터를 복사
//     const currentQuery = { ...route.query };

//     // now 파라미터를 새로운 날짜로 업데이트
//     currentQuery.now = testDate.value ?? '';

//     // URL 쿼리 파라미터를 업데이트하고 페이지 리로드
//     const queryParams = new URLSearchParams();
//     Object.entries(currentQuery).forEach(([key, value]) => {
//         if (value !== undefined && value !== null) {
//             const stringValue = Array.isArray(value) ? value[0] : value;
//             if (stringValue !== null) {
//                 queryParams.append(key, stringValue);
//             }
//         }
//     });

//     const queryString = queryParams.toString();
//     const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`;
//     window.location.href = newUrl;
// };

const createReportLogValue = () => {
    const hasReportData = Boolean(
        computedStore.value.computedModuleData?.ModuleBodyResDtoList &&
            computedStore.value.computedModuleData.ModuleBodyResDtoList.length > 0,
    );
    const dateStr = computedStore.value.currentSelectedEndDate || '';
    const formattedDate = dateStr ? dateStr.split('T')[0] : '';

    return `${formattedDate},${hasReportData}`;
};

const handleClickShareReport = () => {
    if (!computedStore.value.currentSelectedEndDate && !computedStore.value.computedTimeseriesData?.TimeSeriesData)
        return;

    proReportStore.getTrendReportShareToken(computedStore.value?.currentSelectedEndDate ?? '').then(token => {
        if (token) {
            // api 호출
            const domain = import.meta.env.VITE_TREND_REPORT_SHARE_BASE_URL;
            const url = new URL('/trend-report', domain);
            url.searchParams.set('code', token);
            url.searchParams.set('isShared', 'true');

            appShareLink(url.toString());
        }
    });

    saveLog(161, 'SHARE_BUTTON_CLICK', '');
};

// 인앱 진입 시 네이티브 브릿지가 window.setToken / receiveJsonData 로 토큰을 주입하는데,
// 이게 onMounted 보다 늦으면 첫 API가 stale 토큰 또는 빈 토큰으로 나가 401이 난다.
// 쿠키 값만 보면 이전 세션 stale 토큰을 그대로 신뢰해버리므로,
// "이번 세션에서 브릿지가 호출됐는지" (window.__nativeBridgeCalled) 를 기준으로 판단한다.
type NativeBridgeWindow = Window & {
    setToken?: (token: string) => void;
    receiveJsonData?: (data: string) => void;
    __nativeBridgeCalled?: boolean;
};

const waitForToken = (timeoutMs = 15000): Promise<boolean> => {
    const w = window as NativeBridgeWindow;

    // 이번 세션에서 브릿지가 이미 호출됐고 쿠키도 있으면 fresh 토큰이 보장됨 (SPA 재진입 등)
    if (w.__nativeBridgeCalled && Cookies.get('tokenValue')) {
        return Promise.resolve(true);
    }

    return new Promise(resolve => {
        const originalSetToken = w.setToken;
        const originalReceiveJsonData = w.receiveJsonData;

        let settled = false;
        const settle = (success: boolean) => {
            if (settled) return;
            settled = true;
            clearTimeout(deadline);
            w.setToken = originalSetToken;
            w.receiveJsonData = originalReceiveJsonData;
            resolve(success);
        };

        w.setToken = (token: string) => {
            originalSetToken?.(token);
            if (Cookies.get('tokenValue')) settle(true);
        };
        w.receiveJsonData = (data: string) => {
            originalReceiveJsonData?.(data);
            if (Cookies.get('tokenValue')) settle(true);
        };

        const deadline = setTimeout(() => settle(false), timeoutMs);
    });
};

onMounted(async () => {
    window.addEventListener('click', closeTooltip);

    // 인앱(uid 없음, 비-admin) 경로만 네이티브 토큰 주입을 기다린다.
    // uid 경로는 request.ts 에서 자체 토큰 fetch, admin 경로는 API 호출 자체가 없음.
    if (!props.isAdmin && !route.query.uid) {
        const ok = await waitForToken(20000);
        if (!ok) {
            console.error('[trend-report] native token bridge timeout (20s)');
            errorStore.setError({
                errorType: 'GLOBAL_ERROR',
                errorAction: 'CLOSE_MODAL',
                errorMessage: t('error_message_global_error'),
            });
            return;
        }
    }

    // 1. 초기 데이터 가져오기
    setInitData().then(async () => {
        // 2. 초기 데이터 다 가져오고 나면
        nextTick(() => {
            setTimeout(() => {
                readyForGraph.value = true; // 그래프 렌더링 시작
            }, 100);
        });
    });

    const appEl = document.querySelector('.wrapper');
    appEl?.addEventListener('scroll', handleScroll, { passive: true });
});

onUnmounted(() => {
    window.removeEventListener('click', closeTooltip);
    const appEl = document.querySelector('.wrapper');
    appEl?.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped lang="scss">
.pro-report-container {
    min-height: 100%;
    position: relative;
    background: $primary-white;
}
.loading-container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
}

.fit-pro-information-area-wrap {
    padding-top: 5rem;
}

.fit-pro-information-area {
    background: $grey-1;
    padding: 1rem;
    border-radius: 2rem;
    margin: auto 1.5rem;
    text-align: center;

    .content-1 {
        color: $grey-7;
    }

    .content-2 {
        color: $grey-7;
    }

    .go-fitplus-pro-page-btn {
        background: $grey-8;
        border-radius: 1rem;
        padding: 0.5rem 1.5rem;
        color: $pro-secondary-blue;
        margin-top: 1rem;
    }
}

.change-line-total-graph-container {
    position: relative;
    margin-bottom: 1rem;

    &.floating {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 100;
        background-color: $primary-white;
        padding: 10.8rem 0 2.2rem 0;
        backdrop-filter: blur(10px);
        box-shadow: 0px 10px 30px 0px #0000001a;
    }

    .floating-graph-close-btn {
        background: url('../../public/assets/images/ic-close.png') no-repeat center center / 100% 100%;
        width: 3.6rem;
        height: 3.6rem;
        position: absolute;
        top: 0;
        right: 0;
    }
}

.pro-report-wrap {
    padding-top: 5rem;
}

section {
    padding: 0 1.5rem;

    &.summary-sec,
    &.velocity-sec {
        padding-bottom: 5rem;
    }

    &:not(&.summary-sec, &.velocity-sec) {
        padding-bottom: 4rem;
    }

    &.summary-sec {
        position: relative;

        .title {
            width: 80%;
            white-space: pre-line;
        }

        .floating-graph-btn {
            position: fixed;
            z-index: 100;
            top: 5rem;
            right: 3rem;
            width: 4.4rem;
            height: 4.4rem;
            border-radius: 1.5rem;
            border: 1px solid $grey-3;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: $primary-white;
            box-shadow: 0px 10px 20px 0px #c6d2dd40;

            img {
                width: 2.35rem;
                height: 1.8rem;
                object-fit: contain;
            }
        }
    }
}

.body-3--regular {
    line-height: 170%;
    color: $grey-7;
}

.summary-date-text {
    margin-bottom: 0.5rem;
    color: $grey-7;

    span {
        &.boldT {
            margin-right: 0.4rem;
            font-weight: 700;
        }
    }
}

.graph-wrap {
    padding: 1rem 0;

    &.number {
        padding: 2rem 0;
    }
}

.comment-sec-title-wrap {
    display: inline-block;
    align-items: center;
    white-space: pre;

    .title {
        display: inline-block;
        margin-bottom: 1rem;
    }
}

.title {
    display: inline-block;
    margin-bottom: 1rem;
    white-space: pre-line;
    word-break: keep-all;
}

.evaluation-chip {
    display: inline-block;
    padding: 0 0.7rem;
    color: $primary-white;
    border-radius: 0.2rem;
    margin-left: 0.5rem;
    word-break: keep-all;
    transform: translateY(-2px);
}

.one-line-summary {
    background-color: $grey-1;
    padding: 1rem 1.5rem;
    border-radius: 1rem;
    margin-top: 1rem;
}

hr {
    margin: 0;
    background: $grey-3;
    height: 1px;
    border: 0;
    padding: 0 1.5rem;
}

.description-text {
    text-align: right;
    color: $grey-6;
    padding: 5rem 1.5rem;
}

.reference-list {
    display: inline-flex;
    flex-direction: column;
    padding-top: 4rem;

    li {
        color: $grey-7;
        text-decoration: underline;
        display: inline-block;

        & + li {
            margin-top: 0.5rem;
        }
    }
}

.empty-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 1.5rem 6rem 1.5rem;
    box-sizing: border-box;

    img {
        width: 78%;
        height: 78%;
    }

    .empty-text-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: 2rem;

        .empty-big-text {
            color: $grey-7;
            margin-bottom: 1rem;
        }

        .empty-text {
            font-size: 1.5rem;
            text-align: center;
            word-break: keep-all;
        }
    }
}

// 아래로부터 위로 슬라이드 애니메이션
.slide-modal-enter-from {
    transform: translateY(100%);
    opacity: 0;
}

.slide-modal-enter-active {
    transition: all 0.3s ease;
}

.slide-modal-enter-to {
    transform: translateY(0);
    opacity: 1;
}

.slide-modal-leave-from {
    transform: translateY(0);
    opacity: 1;
}

.slide-modal-leave-active {
    transition: all 0.3s ease;
}

.slide-modal-leave-to {
    transform: translateY(100%);
    opacity: 0;
}

// iOS 스크롤 멈춤 방지: fixed는 wrapper가 담당, 카드는 안에서 transform 애니메이션
.tracking-card-slot {
    position: fixed;
    bottom: 1.6rem;
    left: 1.6rem;
    right: 1.6rem;
    z-index: 10;
    pointer-events: none;

    > * {
        pointer-events: auto;
    }
}

// 위로부터 아래로 슬라이드 애니메이션 (카드용)
.slide-card-enter-from {
    transform: translate3d(0, calc(100% + 1.6rem), 0);
}

.slide-card-enter-active {
    transition: transform 0.3s ease;
}

.slide-card-enter-to {
    transform: translate3d(0, 0, 0);
}

.slide-card-leave-from {
    transform: translate3d(0, 0, 0);
}

.slide-card-leave-active {
    transition: transform 0.3s ease;
}

.slide-card-leave-to {
    transform: translate3d(0, calc(100% + 1.6rem), 0);
}

// 테스트용 floating 날짜 선택기
.floating-test-date {
    position: fixed;
    top: 15rem;
    right: 1rem;
    z-index: 1000;
    background: $primary-white;
    border: 1px solid $grey-3;
    border-radius: 1rem;
    padding: 1rem;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 150px;
    box-sizing: border-box;

    .test-date-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.5rem;

        span {
            font-size: 1.4rem;
            font-weight: 600;
            color: $grey-8;
        }

        .close-btn {
            background: none;
            border: none;
            font-size: 1.8rem;
            color: $grey-6;
            cursor: pointer;
            padding: 0;
            width: 2rem;
            height: 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: background-color 0.2s ease;

            &:hover {
                background-color: $grey-2;
            }
        }
    }

    input[type='date'] {
        width: 100%;
        width: -webkit-fill-available;
        padding: 0.5rem;
        border: 1px solid $grey-3;
        border-radius: 0.5rem;
        font-size: 1.4rem;
    }

    button:not(.close-btn) {
        padding: 0.5rem 1rem;
        background: $pro-secondary-blue;
        color: $primary-white;
        border: none;
        border-radius: 0.5rem;
        font-size: 1.4rem;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
            background: $pro-secondary-blue;
        }
    }
}

// 테스트 날짜 버튼
.floating-test-date-btn {
    position: fixed;
    top: 22rem;
    right: 1rem;
    z-index: 999;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: $pro-secondary-blue;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }

    span {
        color: $primary-white;
        font-size: 0.8rem;
        font-weight: 600;
        line-height: 1;
    }
}
:deep(.big-button) {
    width: calc(100% - 3rem);
    margin: 0 1.5rem 0 1.5rem;
    box-sizing: border-box;

    &.share-button {
        margin: 0 1.5rem 7rem 1.5rem;
    }
}

.error-image {
    width: 75%;
    height: 100%;
    object-fit: contain;
    margin-bottom: 1rem;
}

.admin-info-header {
    padding: 2rem 1.5rem 0.5rem;
    display: flex;
    justify-content: flex-end;
    position: relative;
    z-index: 200;
}

.report-info-tooltip-wrap {
    position: relative;
}

.report-info-btn {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.6rem 1rem;
    background: $grey-1;
    border-radius: 0.8rem;
    color: $grey-7;
    border: 1px solid $grey-2;
    cursor: pointer;
    outline: none;

    .info-icon {
        font-size: 1.6rem;
        line-height: 1;
        color: $grey-6;
    }
}

.report-info-tooltip {
    position: absolute;
    top: 4rem;
    right: 0;
    width: 26rem;
    background: white;
    border-radius: 1.2rem;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    padding: 1.6rem;
    border: 1px solid $grey-2;
    z-index: 210;

    &::after {
        content: '';
        position: absolute;
        top: -0.6rem;
        right: 1.2rem;
        width: 1.2rem;
        height: 1.2rem;
        background: white;
        border-left: 1px solid $grey-2;
        border-top: 1px solid $grey-2;
        transform: rotate(45deg);
    }

    .info-row-wrap {
        display: flex;
        flex-direction: column;
        gap: 0.8rem;
    }
}

.tooltip-section {
    &:not(:last-child) {
        margin-bottom: 1.6rem;
        padding-bottom: 1.2rem;
        border-bottom: 1px solid $grey-1;
    }

    .tooltip-title {
        color: $grey-8;
        margin-bottom: 0.8rem;
    }
}

.info-row {
    display: flex;
    justify-content: space-between;
    font-size: 1.3rem;

    .label {
        color: $grey-6;
    }
    .value {
        color: $grey-8;
        font-weight: 500;
    }
}

.cluster-card-wrap {
    display: flex;
    align-items: center;
    gap: 0.8rem;
}

.cluster-card {
    flex: 1;
    background: $grey-1;
    padding: 1rem;
    border-radius: 0.8rem;
    text-align: center;

    .card-label {
        font-size: 1.1rem;
        color: $grey-5;
        margin-bottom: 0.4rem;
    }

    .cluster-name {
        font-size: 1.3rem;
        color: $grey-8;
        margin-bottom: 0.4rem;
        word-break: keep-all;
    }

    .index-row {
        font-size: 1.1rem;
        color: $grey-6;
        display: flex;
        justify-content: center;
        gap: 0.4rem;

        .divider {
            color: $grey-3;
        }
    }

    &.start {
        background: $grey-1;
    }
    &.end {
        background: rgba($pro-secondary-blue, 0.05);
        border: 1px solid rgba($pro-secondary-blue, 0.1);
    }
}

.arrow-icon {
    color: $grey-4;
    font-size: 1.4rem;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
